import React from 'react';
import emailjs from 'emailjs-com';
import resume from '../../../images/Shatabdi.pdf'
import './Contact.css'

const Contact = () => {

    function sendEmail(e) {
        e.preventDefault();

        emailjs.sendForm('gmail', 'template_z59mfhe', e.target, 'O76Zq5PM74rTKCcZ2')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
        e.target.reset();
    }
    return (
        // <div>
        <div style={{ backgroundColor: '#071A52', color: 'white' }}>
            <div className="text-center border-bottom page">
                <h1 className="pt-5">Let's Work Together...</h1>
                <div className="mt-5">
                    <a className="download" href={resume} download="resume">Download My Resume</a>
                </div>
                <h6 className="mt-5">OR</h6>
                <p style={{ marginTop: '10px' }}>Feel Free to Contact</p>
                <div className="text-center formField page">

                    <form onSubmit={sendEmail} className="m-5 p-5 contact-form" role="form" method="post" id="reused_form">

                        <div class="row">
                            <div class="col-sm-6 form-group">
                                <label className="mb-2" for="name"> Your Name:</label>
                                <input type="text" class="form-control" id="name" name="user_name" required />
                            </div>
                            <div class="col-sm-6 form-group">
                                <label className="mb-2" for="email"> Email:</label>
                                <input type="email" class="form-control" id="email" name="user_email" required />
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-sm-12 form-group">
                                <label className="mb-2" for="message"> Message:</label>
                                <textarea class="form-control" type="textarea" id="message" name="message" maxlength="6000" rows="7"></textarea>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 form-group mt-5">
                                <button style={{ color: 'white' }} type="submit" value="Send" class="btn btn-lg btn-default pull-right btnContact border-bottom" >Send &rarr;</button>
                            </div>
                        </div>
                    </form>

                </div>

            </div>

        </div>
    );
};

export default Contact;